import { blockEl, unblockEl } from "./Block";
import MediaUploader from "../modules/MediaUploader";
import popup from "./Popup";

const { __ } = wp.i18n;
/** --------------------------------------------------
 * ReviewActions Default Class
 -------------------------------------------------- */
export default class ReviewActions {
  constructor() {
    this.reviewForm = document.querySelector( '.comment-form' );

    // Required Inputs
    this.isRequired = this.reviewForm.querySelectorAll( '[required]' );

    // Media uploader
    this.uploader = new MediaUploader();

    // Languages
    this.langCode = document.querySelector( 'input[name="wpml_language_code"]' );

    this.init();
  }

  init() {
    this.modal = null;
    this.reqWrap = null;
    this.addHandlers();
  }

  addHandlers() {
    this.reviewForm.addEventListener( 'click', this.onSubmitClick.bind( this ) );
    if ( this.isRequired ) {
      this.isRequired.forEach( field => {
        field.addEventListener( 'change', this.onCheckRequiredFields.bind( this ) );
      } );
    }
  }

  async onSubmitClick( event ) {
    if ( ! event.target.classList.contains( 'btn-submit-review' ) ) {
      return;
    }
    event.preventDefault();

    await this.onPostReview();
  }

  async onPostReview() {
    blockEl( this.reviewForm );

    const formData = new FormData( this.reviewForm );
    formData.append( 'action', 'palram_set_review' );
    formData.append( 'secure', palram.nonces.set_review );

    let response = await this.onSetReviewRequest( formData );
    try {
      this.alertPopup( response );
    } catch ( e ) {
      console.log( e );
    } finally {
      unblockEl( this.reviewForm );
    }
  }

  alertPopup( response ) {
    const popupType = response.success ? 'success' : 'warning';
    const titleText = response.success ? __( "Okay", "canopia" ) : __( "Some error", "canopia" );

    let data = {
      title : titleText,
      type : popupType,
      message : response.message,
    }

    if ( response.success ) {

      let langCode = this.langCode.value;
      let redirectTo;

      if ( response.permalink ) {
        let uri = new URL( response.permalink );
        let params = new URLSearchParams( uri.search );
        if ( langCode !== 'en' ) {
          uri.searchParams.set( 'lang', langCode );
          params.toString();
          redirectTo = uri.href;
        } else {
          redirectTo = response.permalink;
        }
      }
      this.onRedirectToProduct( redirectTo );

      data[ 'link' ] = {
        url : redirectTo,
        text : __( 'Go to product', 'canopia' ),
      }
    } else {
      data[ 'close' ] = {
        text : __( 'Close and fix it', 'canopia' ),
      }
    }

    popup.open( data );
  }

  onCheckRequiredFields( event ) {
    const wrap = event.target.closest( '.comment-form' );

    if ( event.target.value === '' && wrap ) {
      wrap.insertAdjacentHTML( 'beforeend', `<span class="req-wrap fs-12 text-muted">${ __( 'This field is required' ) }</span>` );
    } else {
      this.reqWrap = wrap.querySelector( '.req-wrap' );
      if ( this.reqWrap ) {
        this.reqWrap.remove();
      }
    }
  }

  onRedirectToProduct( url ) {
    if ( ! url ) {
      return;
    }

    let updateTimer;
    if ( updateTimer !== 'undefined' ) {
      clearTimeout( updateTimer );
    }

    updateTimer = setTimeout( () => {
      window.location.href = `${ url }#reviews`;
    }, 2000 );
  }

  async onSetReviewRequest( data ) {
    return $.ajax( {
      method : 'POST',
      url : palram.ajax_url,
      contentType : false,
      processData : false,
      data,
    } );
  }
}
